import React, { FC } from "react"
import { RouteComponentProps } from '@reach/router';
import { getEntity } from './tagTask.reducer';
import { connect } from 'react-redux';
import DetailsPage, { DetailsStateAndDispatchProps } from "layouts/page-wraper/details-page";
import { RootState } from "reducers";
import ProDescriptions from "@ant-design/pro-descriptions";
import { TagTask } from "model/customerCore/tagTask.model";

export interface TagTaskDetailsProps extends DetailsStateAndDispatchProps<TagTask, 'taskRuleConfigType' | 'tagTaskExecutor' | 'customerTagTaskStatus'>,
  RouteComponentProps, StateProps, DispatchProps {
}

const TagTaskDetails: FC<TagTaskDetailsProps> = (props: any) => {

  return (
    <DetailsPage<TagTask, 'taskRuleConfigType' | 'tagTaskExecutor' | 'customerTagTaskStatus'>
      title='标签任务详情'
      hideEdit={true}
      {...props}
    >
      <ProDescriptions<TagTask, 'taskRuleConfigType' | 'tagTaskExecutor' | 'customerTagTaskStatus'>
        column={2}
        columns={props.columns}
        dataSource={props.entity}
      />
    </DetailsPage>);
};

const mapStateToProps = ({ tagTask }: RootState) => ({
  entity: tagTask.entity,
});

const mapDispatchToProps = {
  getEntity,
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(TagTaskDetails);
